// extracted by mini-css-extract-plugin
export default {"table__date":"styles_table__date__-OeNN","table__price":"styles_table__price__iT4ex"};